import React from 'react'
import { Box, Grid, IconButton, Typography } from '@mui/material';
import Iconify from '../../../components/iconify';

const CeluHeader = ({
    title='',
    enable_return,
    enable_close,
    onReturn, 
    onClose
}) => {
    return ( 
        <Grid container alignItems='center'>
            <Grid item>
                {enable_return && <Box sx={{width:40}}>
                    <IconButton onClick={onReturn}><Iconify icon='ic:round-arrow-back-ios' /></IconButton>
                </Box>}
            </Grid>
            <Grid item xs>
                <Typography variant='h5' component='h1' sx={{fontWeight:600}}>
                    {title}
                </Typography>
            </Grid>
            {enable_close &&<Grid item>
                <Box sx={{width:40}}>
                     <IconButton onClick={onClose}><Iconify icon='ic:round-close' /></IconButton>
                </Box>
            </Grid>}
        </Grid>
     );
}
 
export default CeluHeader;